import React from 'react';
import classNames from 'classnames';

import { getInitials } from 'utils/initials';

const sizes = {
  xs: 'w-6 h-6 text-xs',
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-16 h-16 md:w-20 md:h-20 text-xl md:text-2xl',
};

export const ProfileAvatar = ({ name, size = 'md', className }) => {
  const initials = getInitials(name);

  return (
    <div
      className={classNames(
        'flex items-center justify-center rounded-full bg-gradient-to-br from-ui-accent to-ui-accent-hover text-black font-bold shrink-0',
        sizes[size],
        className
      )}
    >
      {initials}
    </div>
  );
};
